import * as React from "react";
import {FormLabel,
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import {useLocation} from "react-router-dom";
import {readQueryParams, searchParam} from "../epic/searchEpic";
import { useUpdateQueryParam } from "../hook";

export const EtatFilter: React.FC = () => {

    const searchLocation = useLocation().search;
    const queryFilters = readQueryParams(searchParam, searchLocation);
    const handleUpdateQueryParam = useUpdateQueryParam();

    const handleChangeStatus = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked)
            handleUpdateQueryParam( `etat`, [...queryFilters.etat, name])
        else {
            handleUpdateQueryParam( `etat`, queryFilters.etat.filter((x: string) => x !== name))
        }
    };


    const availableEtat = ["Prêt pour la mise en vente", "Mis en vente", "Codifié"]

    return (
        <FormControl component="fieldset" sx={{margin: '2px 0'}}>
            <FormLabel component="legend">Etat </FormLabel>
                <FormGroup>
                    <div className="marque-editorial state">

                        {availableEtat.map(x =>
                            <FormControlLabel
                                key={x}
                                control={<Checkbox color="primary" sx={{padding: '0 .5rem 0 1rem', fontSize: '10px'}}
                                                   onChange={handleChangeStatus(x)}
                                                   checked={queryFilters?.etat?.indexOf(x) > -1} size="small"/>}
                                label={x}
                            />
                        )}


                    </div>
                </FormGroup>
        </FormControl>
    )
};
